import React, { useState, useRef, useEffect } from "react";
import "./uploadCsv.css";
import DownloadCloudData from "../../assets/downloadCloudData.png";
import Upload from "../../assets/upload.png";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Back from "../../assets/back.png";
import SpinnerLoader from "../../../../../../../presentationals/Loader/Loader.component";
// import SpinnerLoader from '../../../../../Common/Loader.component';
function UploadCsv({loader ,submitHandler, closeHandler }) {
  const [csvFile, setCsvFile] = useState(null);
  let fileInputRef = useRef(null);

  return (
    <>
      
      {/* <div className="d-flex justify-content-between align-items-center w-100 flex-wrap"> */}
        {/* <div className="col-lg-5 col-sm-12 col-12 col-md-5"> */}
          <div className="mt-4 runBulkCommModalBox" style={{position: "relative"}}>
            <span 
              className="close-btn" 
              onClick={closeHandler}
            >
              ×
            </span>
            <div className="bulkCommHeader">{loader ?"Uploading":'Upload'} CSV File</div>

            <div
              style={{
                width: "100%",
                height: "8rem",
                backgroundColor: "rgba(219, 233, 255, 0.70)",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "1.5rem",
                marginBottom: "0.5rem",
                position: "relative"
              }}
            >
              <div
                style={{
                  width: "90%",

                  padding: "1rem",
                  backgroundColor: "rgba(219, 233, 255, 0.70)",
                  border: "1px dashed black",
                  cursor: "pointer",
                  borderRadius:"6px"
                }}
                className="d-flex justify-content-center align-items-center m-auto rounded"
                onClick={(e) => fileInputRef.click()}
              >
                <div className="d-inline-flex align-items-center">
                  {csvFile ? (
                    <>
                      <InsertDriveFileIcon
                        style={{
                          color: "rgba(43, 120, 255, 0.7)",
                          marginRight: "0.6rem",
                        }}
                      />
                      <span style={{ color: "#2B78FF" }} className="">
                        {csvFile.name.substring(0, 15)}
                        {csvFile.name.length > 15 && "..."}
                      </span>
                    </>
                  ) : (
                    <>
                      <img
                        src={Upload}
                        width={20}
                        height={20}
                        className="mx-2"
                      />
                      <span style={{ color: "rgba(0, 0, 0, 0.40)" }}>
                        Click here to Upload CSV File
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          {loader ?
        <SpinnerLoader />:  
        
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <button
                title="Submit"
                type="button"
                className="sendBtn"
                style={{marginRight:"1rem"}}
                onClick={() => submitHandler(csvFile)}
              >
                Submit
              </button>
              <button
                title="clear"
                type="button"
                className="sendBtn"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => {
                  setCsvFile(null);
                }}
              >
                clear
              </button>
            </div>
}
          </div>
        {/* </div> */}
     
        <input
          type="file"
          accept=".csv, .xls, .xlsx"
          style={{ display: "none" }}
          // onChange={test}
          onChange={(e) => {
            setCsvFile(e.target.files[0]);
          }}
          ref={(fileInput) => (fileInputRef = fileInput)}
        />
      {/* </div> */}
    
    </>
  );
}

export default UploadCsv;
